<mat-expansion-panel
  class="box-shadow border-radius-0"
  (afterExpand)="onExpand()"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">flight_land</mat-icon>
      <span>Inbound Flight</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div
      *ngIf="{
        inboundFlightStatus: inboundFlightStatus$ | async,
        inboundCrew: inboundCrew$ | async
      } as vm"
    >
      <app-data-box
        *ngIf="
          vm.inboundFlightStatus?.isLoading || vm.inboundFlightStatus?.response
        "
        headerTitle="Flight Status"
        [dataItems]="vm.inboundFlightStatus?.response?.dataItems"
        [isLoading]="
          vm.inboundFlightStatus?.isLoading && !vm.inboundFlightStatus?.response
        "
        class="mt-24"
      ></app-data-box>
      <a
        *ngIf="vm.inboundFlightStatus?.response"
        [href]="
          getFlightAwareLink(
            vm.inboundFlightStatus?.response?.flightNumber || ''
          )
        "
        target="_blank"
        class="link track-link font-bold text-sm thin-gray-border mt-24"
      >
        <mat-icon class="icon-sm">location_on</mat-icon>
        Track</a
      >
      <div *ngIf="vm.inboundFlightStatus?.isCompleteWithNoResponse()">
        <div class="text-center text-sm">Inbound flight unavailable</div>
      </div>

      <app-data-box headerTitle="Pilots" class="mt-24">
        <div class="data-box-content">
          <div *ngIf="vm.inboundCrew?.isLoading && !vm.inboundCrew?.response">
            <div class="flex-center p-16">
              <mat-spinner color="accent" [diameter]="32"></mat-spinner>
            </div>
          </div>
          <app-crew-table
            *ngIf="vm.inboundCrew?.response as crewList"
            [crewList]="crewList.pilots"
            [showSeqNumbers]="true"
          ></app-crew-table>
          <div *ngIf="vm.inboundCrew?.isCompleteWithNoResponse()">
            <div class="text-center text-sm p-16">Inbound crew unavailable</div>
          </div>
        </div>
      </app-data-box>
      <div class="data-status">
        <app-data-status
          [isLoading]="
            vm.inboundCrew?.isLoading || vm.inboundFlightStatus?.isLoading
          "
          [timestamp]="vm.inboundFlightStatus?.response?.timestamp"
          (refresh)="refresh()"
        ></app-data-status>
      </div>
      <mat-progress-bar
        *ngIf="vm.inboundCrew?.isLoading || vm.inboundFlightStatus?.isLoading"
        class="progress-bar-bottom"
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>
